export const NAV_LINKS = {
  HOME: "/",
  COURSES: "/courses",
  LEARNET_INSTITUTE: "/learnet-institute",
  ABOUT: "/about-us",
  PARTNERS: "/partners",
  CONTACT_US: "/contact-us",
  CORPORATE_CHANGEMAKERS:"/csr",
}
